var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.830078,
    width: 40.4286,
    height: 39,
    rx: 5.5,
    fill: "#FFF8F5",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.9173 15.9245V21.5391C30.9173 23.9661 29.2923 25.5911 26.8652 25.5911H24.6673V20.5495C24.6673 19.4766 24.2402 18.4453 23.4798 17.6849L20.9902 15.2057C20.2298 14.4453 19.1986 14.0182 18.1257 14.0182H16.334V13.4349C16.334 11.0078 17.959 9.38281 20.3861 9.38281H24.3757C25.4486 9.38281 26.4798 9.8099 27.2402 10.5703L29.7298 13.0599C30.4902 13.8203 30.9173 14.8516 30.9173 15.9245Z",
    stroke: "#FF8047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6673 20.5488V26.1634C24.6673 28.6009 23.0423 30.2155 20.6152 30.2155H14.1361C11.709 30.2155 10.084 28.6009 10.084 26.1634V18.0697C10.084 15.6322 11.709 14.0176 14.1361 14.0176H18.1257C19.1986 14.0176 20.2298 14.4447 20.9902 15.2051L23.4798 17.6842C24.2402 18.4447 24.6673 19.4759 24.6673 20.5488Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon6);
export default __webpack_public_path__ + "static/media/feature-icon-6.ea0c6a68f606b334d58341c40a8d6f1a.svg";
export { ForwardRef as ReactComponent };